export const TERRA_ASSETS = 'https://assets.hexxagon.io';
export const FINDER = 'https://finder.terra-classic.hexxagon.io';

export const DEFAULT_DECIMALS = 6;
